export default {
  EDITING: 'EDITING',
  SAVING: 'SAVING',
  SAVED: 'SAVED',
  ERROR: 'ERROR',
  VISUALIZING: 'VISUALIZING',
};
